module.exports = __webpack_public_path__ + "img/about-us.1918442c.png";